import React, { useCallback, useState } from 'react';
import {
  StyledCheckboxWrapper,
  StyledRadioButton,
} from './styles/Inputs.styled';
import { InputProps } from './types/Input.types';

const RadioButton: React.FC<
  InputProps & React.InputHTMLAttributes<HTMLInputElement>
> = ({
  inputSize = 'medium',
  inputState = 'default',
  wrapperClassName,
  label,
  ...props
}) => {
  const [checked, setChecked] = useState<boolean>(
    props.checked ?? props.value == 'on'
  );
  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      props.onChange && props.onChange(e);
      setChecked(e.target.checked);
    },
    [props]
  );

  return (
    <StyledCheckboxWrapper className={wrapperClassName}>
      <label htmlFor={props.id}>
        <StyledRadioButton
          type="radio"
          $checked={checked}
          $inputSize={inputSize}
          {...props}
          onChange={onChange}
        />
        {label && <span>{label}</span>}
      </label>
    </StyledCheckboxWrapper>
  );
};

export default RadioButton;
